// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__15zKv","label":"Radio_label__1lCXk","checkMark":"Radio_checkMark__2SjTD","disabled":"Radio_disabled__1g_nB"};